module.exports = __webpack_public_path__ + "static/media/29COICT4.b2628e28.jpg";